module.exports = __webpack_public_path__ + "jpg/puzzle-mobile.jpg?042428bc3587454a06ff669c850994d5";